import { useContext, useMemo, useState } from 'react';
import { ErrorBoundaryContext } from '../context/ErrorBoundaryContext';
export const useErrorBoundary = () => {
    const context = useContext(ErrorBoundaryContext);
    const [state, setState] = useState({
        error: null,
        hasError: false,
    });
    const memoized = useMemo(() => ({
        resetBoundary: () => {
            context.resetErrorBoundary();
            setState({ error: null, hasError: false });
        },
        showBoundary: (error) => {
            setState({
                error,
                hasError: true,
            });
        },
    }), [context.resetErrorBoundary]);
    if (state.hasError) {
        throw state.error;
    }
    return memoized;
};
//# sourceMappingURL=useErrorBoundary.js.map